import compileGeneralAdmissionCacheKey from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/compilers/compileGeneralAdmission/compileGeneralAdmissionCacheKey';
import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SEAT,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import getSeatUpperParent from '%paysera_seat_selection/js/seatSelection/services/getSeatUpperParent';
import compileUniqueSeatParents from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/seat/compileUniqueSeatParents';
import { PROPS_CHANGED } from '%paysera_seat_selection/js/seatSelection/config/changeSet';

export default ({ GeneralAdmission, Seat }, { payload }) => {
    const { models } = payload;

    const parents = [];
    models.forEach((seating) => {
        const { objectType, hash } = seating;

        if (objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
            const generalAdmission = GeneralAdmission.get({ hash });
            compileGeneralAdmissionCacheKey(generalAdmission, Math.random());
        }
        if (objectType === OBJECT_TYPE_SEAT) {
            const seat = Seat.get({ hash });
            parents.push(getSeatUpperParent(seat));
        }
    });

    compileUniqueSeatParents(parents, { seat: [PROPS_CHANGED] });
};
